import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const CircleIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    </SvgIcon>
  );
};
